import { saveAuthReturnTo } from './authReturnTo';

const LAST_ACTIVE_KEY = 'venue_dashboard_last_active_at';
const IDLE_MS = 24 * 60 * 60 * 1000;

const readLastActiveAt = () => {
  try {
    const raw = localStorage.getItem(LAST_ACTIVE_KEY);
    if (raw == null || raw === '') return null;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const getVenueDashboardIdleMs = () => IDLE_MS;

/** Record venue dashboard UI or API activity (rolling 24h window). */
export const touchVenueDashboardActivity = () => {
  try {
    localStorage.setItem(LAST_ACTIVE_KEY, String(Date.now()));
  } catch {
    // no-op when storage is unavailable
  }
};

const isAccessTokenExpired = (token) => {
  if (!token) return true;
  try {
    const segment = token.split('.')[1];
    if (!segment) return true;
    const payload = JSON.parse(atob(segment.replace(/-/g, '+').replace(/_/g, '/')));
    if (!payload?.exp) return false;
    return Date.now() >= payload.exp * 1000;
  } catch {
    return true;
  }
};

/**
 * True when the venue dashboard needs a fresh backend login:
 * missing JWT, JWT past exp, or no UI/API activity for 24+ hours.
 */
export const requiresVenueDashboardRelogin = () => {
  const token = localStorage.getItem('access_token');
  if (!token) return true;
  if (isAccessTokenExpired(token)) return true;

  const lastActive = readLastActiveAt();
  if (lastActive == null) {
    // Existing sessions before tracking: allow this visit and start the clock.
    return false;
  }
  return Date.now() - lastActive > IDLE_MS;
};

export const clearVenueDashboardAuth = () => {
  try {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    localStorage.removeItem(LAST_ACTIVE_KEY);
  } catch {
    // no-op
  }
};

/** Clear backend session and hard-navigate to dashboard login (full reload). */
export const forceVenueDashboardRelogin = (returnPath) => {
  const fallback =
    typeof window !== 'undefined'
      ? `${window.location.pathname}${window.location.search}`
      : '/venue-dashboard';
  const path = returnPath && String(returnPath).startsWith('/') ? returnPath : fallback;
  saveAuthReturnTo(path);
  clearVenueDashboardAuth();
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams({ session: 'expired' });
    try {
      const returnUrl = new URL(path, window.location.origin);
      const venueId = returnUrl.searchParams.get('venueId');
      if (venueId) params.set('venueId', venueId);
    } catch {
      // keep session=expired only
    }
    window.location.assign(`/dashboard-login?${params.toString()}`);
  }
};
